import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function LinkedinCircleIcon(props: IconProps) {
  return (
    <Icon fill="none" viewBox="0 0 24 24" {...props}>
      <Box as="circle" cx="12" cy="12" r="12" fill="#007EBB" />
      <Box
        as="path"
        fill="#fff"
        fillRule="evenodd"
        d="M19.035 18.207h-2.891v-4.924c0-1.35-.513-2.104-1.582-2.104-1.162 0-1.77.785-1.77 2.104v4.924h-2.785v-9.38h2.786v1.264s.837-1.55 2.828-1.55c1.99 0 3.414 1.215 3.414 3.727v5.939ZM6.683 7.599a1.724 1.724 0 0 1-1.717-1.73c0-.956.769-1.731 1.717-1.731.95 0 1.718.775 1.718 1.73 0 .956-.769 1.731-1.718 1.731ZM5.245 18.207H8.15v-9.38H5.245v9.38Z"
        clipRule="evenodd"
      />
    </Icon>
  );
}
